import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { GetServiceCaller } from "../../../services/serviceCaller";
import { API_URL } from "../../../constants";
import Dynamic_PR_table from "../../../components/Dynamic_PR_table";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../constants/layout/store/filterSlice";
import moment from "moment";

const UpcomingJoineer = () => {
  const todayDate = moment().format("YYYY-MM-DD");
  const nextMonthDate = moment().add(1, "months").format("YYYY-MM-DD");

  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Upcoming Joiners"));
  }, []);
  const [searchTerm, setSearchTerm] = useState("");
  const [newJoinersListData, setNewJoinersListData] = useState([]);
  const [statusList, setStatusList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterFormData, setFilterData] = useState([
    { label: "Status", value: "" },
    { label: "From Date", value: moment(todayDate).format("DD-MMM-YYYY") },
    { label: "To Date", value: moment(nextMonthDate).format("DD-MMM-YYYY") },
  ]);
  const [apiStatus, SetApiStatus] = useState(undefined);

  const columns = {
    FullName: { text: "Name", align: "start", visible: true },
    JobTitle: { text: "Designation", align: "left", visible: true },
    CandidateStatus: { text: "Status", align: "left", visible: true },
    Date: { text: "Joining Date", align: "center", visible: true },
    RecruiterName: { text: "Recruiter", align: "start", visible: true },
    JoiningLocation: { text: "Location", align: "start", visible: true },
  };
  const formDatas = [
    { name: "Status", type: "Select", options: [...statusList] },
    { name: "From Date", type: "Date" },
    { name: "To Date", type: "Date" },
  ];
  const handleChange = (e, name) => {
    setFilterData((prevFormData) => {
      // Check if the label already exists
      const existingLabelIndex = prevFormData.findIndex(
        (item) => item.label === name
      );

      // If the label exists, update its value
      if (existingLabelIndex !== -1) {
        const updatedFormData = prevFormData.map((item, index) =>
          index === existingLabelIndex
            ? { ...item, value: e.value !== undefined ? e.value : e }
            : item
        );
        return updatedFormData;
      } else {
        // If the label doesn't exist, add a new label-value pair
        return [
          ...prevFormData,
          {
            label: name,
            value: e.value !== undefined ? e.value : e, // Assuming e is an event object
          },
        ];
      }
    });
  };
  useEffect(() => {
    fetchNewJoineers();
  }, []);

  const fetchNewJoineers = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}report/12?P_Status=&P_FromDate=${todayDate}&P_ToDate=${nextMonthDate}`
      );
      SetApiStatus(response?.status);
      if (response.status === 200) {
        const joinerData = response?.data?.data?.data;
        // Format joiningDate using moment (adjust key if needed)
        const formattedJoinerData = Array.isArray(joinerData)
          ? joinerData.map((item) => ({
              ...item,
              Date: item.Date ? moment(item.Date).format("YYYY-MM-DD") : "",
            }))
          : [];
        setNewJoinersListData(formattedJoinerData);
        setLoading(false);
        // status List
        const listStatus = response?.data?.data?.status?.map((item) => ({
          value: item.value,
          label: item.text,
        }));
        setStatusList(listStatus);
      } else {
        console.error(
          "Failed to fetch Upcoming Joiners. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Upcoming Joiners:", error);
    }
  };

  const handleGetData = async () => {
    SetApiStatus(undefined);
    try {
      const response = await GetServiceCaller(
        `${API_URL}report/12?P_Status=${
          filterFormData.find((o) => o.label === "Status")
            ? filterFormData.find((o) => o.label === "Status").value
            : ""
        }&P_FromDate=${
          filterFormData.find((o) => o.label === "From Date")
            ? moment(
                filterFormData.find((o) => o.label === "From Date").value
              ).format("YYYY-MM-DD")
            : todayDate
        }&P_ToDate=${
          filterFormData.find((o) => o.label === "To Date")
            ? moment(
                filterFormData.find((o) => o.label === "To Date").value
              ).format("YYYY-MM-DD")
            : nextMonthDate
        }`
      );
      SetApiStatus(response?.status);
      const joinerData = response?.data?.data?.data;
      // Format joiningDate using moment (adjust key if needed)
      const formattedJoinerData = Array.isArray(joinerData)
        ? joinerData.map((item) => ({
            ...item,
            Date: item.Date ? moment(item.Date).format("YYYY-MM-DD") : "",
          }))
        : [];
      setNewJoinersListData(formattedJoinerData);
      setLoading(false);
      // status List
      const listStatus = response?.data?.data?.status?.map((item) => ({
        value: item.value,
        label: item.text,
      }));
      setStatusList(listStatus);
    } catch (error) {
      console.error("Error fetching skills:", error);
    }
  };
  const handleReset = () => {
    fetchNewJoineers();
    setFilterData([
      { label: "Status", value: "" },
      { label: "From Date", value: moment(todayDate).format("DD-MMM-YYYY") },
      { label: "To Date", value: moment(nextMonthDate).format("DD-MMM-YYYY") },
    ]);
  };
  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <div className="row">
            <Dynamic_PR_table
              data={newJoinersListData}
              columns={columns}
              itemsPerPage={10}
              isSorting={true}
              formDatas={formDatas}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              isApiStatus={apiStatus}
              isRequiredStatus={true}
              isFilterRequired={true}
              handleChange={handleChange}
              filterFormData={filterFormData}
              handleGetData={handleGetData}
              handleReset={handleReset}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default UpcomingJoineer;
